/**
 * modal.js — ネイティブ <dialog> の開閉 (Modaal の置換)
 *
 * マークアップ契約:
 *   <button data-modal-open="モーダルのid"> … 開く
 *   <dialog class="c-modal" id="…"> … [data-modal-close] で閉じる。背景クリックでも閉じる。
 */
export function initModal() {
  document.querySelectorAll('[data-modal-open]').forEach((trigger) => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      const dlg = document.getElementById(trigger.getAttribute('data-modal-open'));
      if (dlg && typeof dlg.showModal === 'function') dlg.showModal();
    });
  });

  document.querySelectorAll('dialog.c-modal').forEach((dlg) => {
    dlg.querySelectorAll('[data-modal-close]').forEach((btn) => {
      btn.addEventListener('click', () => dlg.close());
    });
    // 背景 (::backdrop) クリックで閉じる
    dlg.addEventListener('click', (e) => {
      if (e.target === dlg) dlg.close();
    });
  });
}
